import React from 'react';
import { Handle, Position } from 'reactflow';

const SubflowGroupNode = ({ data, id }) => {
  const { label, handles = [], onExpandNode, activated_handles = [] } = data;

  const handleCollapse = (e) => {
    e.stopPropagation();
    if (onExpandNode) {
      onExpandNode(id);
    }
  };

  return (
    <div
      className="subflow-group-node"
      style={{
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        position: 'relative',
      }}
    >
      <div className="subflow-group-header" style={{ pointerEvents: 'all', position: 'relative', zIndex: 10 }}>
        <span className="subflow-group-label">{label}</span>
        <button className="subflow-group-collapse-btn" onClick={handleCollapse} style={{ pointerEvents: 'all' }} title="Collapse subflow">
          −
        </button>
      </div>
      <Handle type="target" position={Position.Left} />
      {handles.length > 0 && (
        <div className="subflow-group-handles" style={{ pointerEvents: 'all' }}>
          {handles.map((handle, index) => {
            const isActivated = activated_handles.some((h) => h === handle.id);
            return (
              <div className="handle-wrapper" key={handle.id || index}>
                <Handle id={handle.id} type="source" position={Position.Right} className={`handle ${isActivated ? 'activated' : ''}`} />
                <span className="handle-label me-2">{handle.label}</span>
              </div>
            );
          })}
        </div>
      )}
      {handles.length === 0 && <Handle type="source" position={Position.Right} />}
    </div>
  );
};

export default SubflowGroupNode;
